import { render, staticRenderFns } from "./related.vue?vue&type=template&id=4568b80c&scoped=true&"
import script from "./related.vue?vue&type=script&lang=js&"
export * from "./related.vue?vue&type=script&lang=js&"
import style0 from "./related.vue?vue&type=style&index=0&id=4568b80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568b80c",
  null
  
)

/* custom blocks */
import block0 from "./related.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/app/components/ui/icon.vue').default,UiTransition: require('/app/components/ui/transition.vue').default})
